const actions = {
  LIST_SUCURSAL: 'LIST_SUCURSAL',
  LIST_SUCURSAL_SELECTBOX: 'LIST_SUCURSAL_SELECTBOX',
  CREATE_SUCURSAL: 'CREATE_SUCURSAL',
  READ_SUCURSAL: 'DREA_SUCURSAL',
  UPDATE_SUCURSAL: 'UPDATE_SUCURSAL',
  DELETE_SUCURSAL: 'DELETE_SUCURSAL',
  LIST_SUCURSAL_UNIDADES_MEDICAS: 'LIST_SUCURSAL_UNIDADES_MEDICAS',
  CLEAR_SUCURSAL_UNIDADES_MEDICAS: 'CLEAR_SUCURSAL_UNIDADES_MEDICAS',

  sucursalList: data => {  
    return {
      type: actions.LIST_SUCURSAL,
      data,
    };
  },

  sucursalListSelectBox: data => {
    return {
      type: actions.LIST_SUCURSAL_SELECTBOX,
      data,
    };
  },

  sucursalCreate: data => {
    return {
      type: actions.CREATE_SUCURSAL,
      data,
    };
  },

  sucursalRead: data => {
    return {
      type: actions.READ_SUCURSAL,
      data,
    };
  },

  sucursalUpdate: data => {
    return {
      type: actions.UPDATE_SUCURSAL,
      data,
    };
  },

  sucursalDelete: () => {
    return {
      type: actions.DELETE_SUCURSAL,      
    };
  },

  sucursalUnidadesMedicasList: data => {  
    return {
      type: actions.LIST_SUCURSAL_UNIDADES_MEDICAS,
      data,
    };
  },

  sucursalUnidadesMedicasClear: () => {
    return {
      type: actions.CLEAR_SUCURSAL_UNIDADES_MEDICAS,      
    };
  },

};

export default actions;
